import { render, staticRenderFns } from "./CurrenciesSelector.vue?vue&type=template&id=00237ff2&scoped=true"
import script from "./CurrenciesSelector.vue?vue&type=script&lang=js"
export * from "./CurrenciesSelector.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./CurrenciesSelector.vue?vue&type=style&index=0&id=00237ff2&prod&lang=scss&scoped=true")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "00237ff2",
  "090c0edf"
  
)

export default component.exports